import { GlanceCard } from '../shell/GlanceCard';
import { COLORS } from '../../constants/theme';

interface VotingRulesCardProps {
  leadRequirement: number;
  variant: 'card' | 'plain';
}

const PARAGRAPHS_STYLE: React.CSSProperties = {
  fontSize: 13,
  color: COLORS.text.tertiary,
  lineHeight: 1.5,
};

/**
 * SF-152: "How Voting Works" explanation, extracted from Politics.tsx's inline intro so both
 * shells render identical copy from one source. `variant="plain"` renders today's bare `<div>`
 * (border/background/padding, no heading) byte-identical for desktop; `variant="card"` wraps the
 * same three paragraphs in a `GlanceCard` (which cannot render without a heading) for mobile.
 */
export function VotingRulesCard({ leadRequirement, variant }: VotingRulesCardProps) {
  const paragraphs = (
    <>
      <p style={{ margin: '0 0 6px' }}>
        Each province in the kingdom may cast a single vote to elect a <span style={{ color: COLORS.gold }}>Monarch</span>.
        The Monarch grants kingdom-wide bonuses to income, rune production, food, and defenses.
      </p>
      <p style={{ margin: '0 0 6px' }}>
        Your vote weight is determined by your honour title — a Peasant casts 1 vote while a Prince casts 10.
        {leadRequirement > 0 ? (
          <> In kingdoms of more than six provinces, the leading candidate must also hold at least a <strong>+{leadRequirement}</strong>-vote lead over the runner-up to be crowned.</>
        ) : (
          <> In small kingdoms like yours (six provinces or fewer), a simple majority is enough to be crowned.</>
        )}
        {' '}A province controlling more than half of the kingdom's total networth may also install the Monarch of its choice outright.
      </p>
      <p style={{ margin: 0 }}>
        You may change or retract your vote at any time. When support collapses, the throne becomes vacant until a new majority forms.
      </p>
    </>
  );

  if (variant === 'card') {
    return (
      <GlanceCard title="How Voting Works">
        <div style={PARAGRAPHS_STYLE}>{paragraphs}</div>
      </GlanceCard>
    );
  }

  return (
    <div style={{ marginBottom: 12, padding: '12px 14px', background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 6, ...PARAGRAPHS_STYLE }}>
      {paragraphs}
    </div>
  );
}
